module.exports = __webpack_public_path__ + "img/queen.a3da15e8.svg";